import React from 'react';
import { Outlet } from 'react-router-dom';

const LoginLayout = () => {
  return (
    <div className='h-screen w-full items-center justify-center'>
      <Outlet />
    </div>
  );
};

export default LoginLayout;
